import { Avatar, Box, Button, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getColorIndexes } from "../../../../utils/colorUtils";
import { setIsSendingRoomData } from "../../../services/store/slice/CallSlice";
import { startGroupCall } from "../../../services/signalRService/signalRService";
import { useTwilio } from "../../../services/context/TwilioContext";
import { settings as s } from "../../../services/Settings";
import CallIcon from "@mui/icons-material/Call";
import CallEndIcon from "@mui/icons-material/CallEnd";
import groupCallRingtone from "../../../../assets/audio/GroupCall_Ringtone.mp3";
import addNotification from "react-push-notification";

function GroupCallNotification() {
  const dispatch = useDispatch();
  const user_id = localStorage.getItem("user_id");
  const username = localStorage.getItem("username");
  const audioRef = React.useRef(null);
  const { isSendingRoomData } = useSelector((state) => state.call);
  const { handleJoinAsMainParticipant } = useTwilio();
  const lightColors = ["#FFCDD2", "#F8BBD0", "#E1BEE7", "#D1C4E9", "#C5CAE9"];
  const darkColors = ["#D32F2F", "#C2185B", "#7B1FA2", "#512DA8", "#303F9F"];
  const [position, setPosition] = React.useState(() => ({
    x: (window.innerWidth - 300) / 2,
    y: 20,
  }));
  // const [position, setPosition] = React.useState(() => ({
  //   x: window.innerWidth - 320,
  //   y: window.innerHeight - 240,
  // }));
  const handleDrag = (e) => {
    setPosition({ x: e.clientX, y: e.clientY });
  };

  const handleDragStart = (e) => {
    const img = new Image();
    img.src =
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGNgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=";
    img.width = 0;
    img.height = 0;
    e.dataTransfer.setDragImage(img, 0, 0);
  };

  const getInitials = (name) => {
    if (!name) return "";
    const trimmedName = name?.trim();
    if (/^\d+$/.test(trimmedName) || trimmedName.startsWith("+1")) return "+1";
    const words = trimmedName.split(" ");
    const first = words[0]?.charAt(0).toUpperCase();
    const last =
      words.length > 1 ? words[words.length - 1]?.charAt(0).toUpperCase() : "";
    return first + last;
  };

  // useEffect to play/stop ringtone
  React.useEffect(() => {
    let timeoutId;
    if (
      isSendingRoomData?.End === true &&
      isSendingRoomData?.ToUserIds?.includes(user_id) &&
      isSendingRoomData?.GroupPicPath !== "rejected"
    ) {
      addNotification({
        title: isSendingRoomData?.RoomName,
        message: `is calling you from a group`,
        theme: "dark",
        position: "bottom-left",
        duration: 10000,
        icon: isSendingRoomData?.GroupPicPath
          ? `${s?.baseUrl}${isSendingRoomData?.GroupPicPath}`
          : getInitialsIcon(isSendingRoomData?.RoomName),
        native: true,
        onClick: () => {
          window.moveTo(500, 100);
          window.focus();
        },
      });
      audioRef.current = new Audio(groupCallRingtone);
      audioRef.current.loop = true;
      audioRef.current
        .play()
        .catch((err) => console.error("Ringtone error:", err));

      // Set TimeOut to hide Notification popup
      timeoutId = setTimeout(() => {
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
          audioRef.current = null;
        }
        dispatch(setIsSendingRoomData(null));
      }, 30000);
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        audioRef.current = null;
      }
      clearTimeout(timeoutId);
    };
  }, [isSendingRoomData, user_id]);

  return (
    <>
      {isSendingRoomData?.End === true &&
        isSendingRoomData?.ToUserIds?.includes(user_id) &&
        isSendingRoomData?.GroupPicPath !== "rejected" && (
          <Box
            draggable
            onDrag={handleDrag}
            onDragStart={handleDragStart}
            onDragEnd={(e) => {
              setPosition({ x: e.clientX, y: e.clientY });
            }}
            sx={{
              position: "fixed",
              top: position.y,
              left: position.x,
              width: 300,
              height: 220,
              bgcolor: "#2f2f2f",
              borderRadius: 2,
              p: 2,
              zIndex: 9999,
              boxShadow: 5,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              color: "white",
              cursor: "move",
            }}
          >
            <Avatar
              sx={{
                height: 70,
                width: 70,
                fontSize: 18,
                fontWeight: "bold",
                bgcolor: isSendingRoomData?.GroupPicPath
                  ? "transparent"
                  : getColorIndexes(
                      isSendingRoomData?.RoomName,
                      lightColors,
                      darkColors
                    ).lightColor,
                color: isSendingRoomData?.GroupPicPath
                  ? "transparent"
                  : getColorIndexes(
                      isSendingRoomData?.RoomName,
                      lightColors,
                      darkColors
                    ).darkColor,
              }}
              src={
                isSendingRoomData?.GroupPicPath
                  ? `${s.baseUrl}${isSendingRoomData.GroupPicPath}`
                  : null
              }
            >
              {getInitials(isSendingRoomData?.RoomName)}
            </Avatar>

            <Box textAlign="center">
              <Typography sx={{ fontWeight: 600, fontSize: 20 }}>
                {isSendingRoomData?.RoomName}
              </Typography>
              <Typography sx={{ fontSize: 16, color: "#ccc" }}>
                is calling you from a group
              </Typography>
            </Box>

            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                onClick={() => {
                  if (audioRef.current) {
                    audioRef.current.pause();
                    audioRef.current.currentTime = 0;
                    audioRef.current = null;
                  }
                  handleJoinAsMainParticipant(
                    username,
                    user_id,
                    isSendingRoomData?.ToUserIds,
                    isSendingRoomData?.RoomName,
                    false,
                    isSendingRoomData?.IsParticipate
                  );
                  dispatch(setIsSendingRoomData(null));
                }}
                variant="contained"
                size="medium"
                sx={{
                  bgcolor: "#43A047",
                  minWidth: 0,
                  width: 48,
                  height: 48,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "&:hover": { bgcolor: "#388E3C" },
                }}
              >
                <CallIcon fontSize="small" />
              </Button>
              <Button
                onClick={() => {
                  if (audioRef.current) {
                    audioRef.current.pause();
                    audioRef.current.currentTime = 0;
                    audioRef.current = null;
                  }
                  startGroupCall(
                    username,
                    isSendingRoomData?.RoomName,
                    user_id,
                    [isSendingRoomData?.fromUserId],
                    "rejected",
                    true,
                    false
                  );
                  dispatch(setIsSendingRoomData(null));
                }}
                variant="contained"
                size="medium"
                sx={{
                  bgcolor: "#E53935",
                  minWidth: 0,
                  width: 48,
                  height: 48,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "&:hover": { bgcolor: "#D32F2F" },
                }}
              >
                <CallEndIcon fontSize="small" />
              </Button>
            </Box>
          </Box>
        )}
    </>
  );
}

const getInitialsIcon = (name = "") => {
  const lightColors = ["#FFCDD2", "#F8BBD0", "#E1BEE7", "#D1C4E9", "#C5CAE9"];
  const darkColors = ["#D32F2F", "#C2185B", "#7B1FA2", "#512DA8", "#303F9F"];

  const initials = name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .substring(0, 2)
    .toUpperCase();

  const { lightColor, darkColor } = getColorIndexes(
    name,
    lightColors,
    darkColors
  );

  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
      <rect width="100%" height="100%" fill="${lightColor}" />
      <text x="50%" y="55%" font-size="40" fill="${darkColor}" text-anchor="middle" dominant-baseline="middle" font-family="Arial, sans-serif">${initials}</text>
    </svg>
  `;

  return `data:image/svg+xml;base64,${btoa(svg)}`;
};

export default GroupCallNotification;
